import React, { useContext, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { Button, Icon } from 'semantic-ui-react';

import '../css/CourseResourceFilterLauncherButton.less';

import { SatCoreRegister } from '../SatCoreRegistry';

import { DIALOG_NAMES } from '../managers/DialogManager';

const CourseResourceFilterLauncherButton = observer((props) => {
  const { t } = props;

  const {
    classroomManager,
    courseManager,
    courseResourceFilterManager,
    dialogManager
  } = useContext(MobXProviderContext);

  const [isLoadingCategories, setIsLoadingCategories] = useState(false);

  const handleLaunchFilterModal = async () => {
    // ensure we have the latest categories and tags before opening the modal
    setIsLoadingCategories(true);

    const categories = await courseResourceFilterManager.fetchCourseResourceCategoriesAndTags({
      classroomId: classroomManager.currentClassroomId,
      courseContentItemId: courseManager.currentCourseId,
      courseResourceElementId: courseManager.currentElementId,
      includeAlignments: courseManager.includeAlignments
    });

    courseResourceFilterManager.setAvailableCourseResourceFilterCategories(categories);
    setIsLoadingCategories(false);

    dialogManager.setOpenDialog(DIALOG_NAMES.COURSE_RESOURCE_FILTER_MODAL, {
      onClose: () => {
        dialogManager.closeDialog(DIALOG_NAMES.COURSE_RESOURCE_FILTER_MODAL);
      }
    });
  };

  const selectedCount = courseResourceFilterManager.selectedCourseResourceFilterTagIds?.length || 0;

  const isCourseResourceFilterModalOpen = dialogManager.openedDialogs.has(DIALOG_NAMES.COURSE_RESOURCE_FILTER_MODAL);

  const buttonLabel = selectedCount > 0 ? (
    t('filterResourceListButtonWithCount', { count: selectedCount })
  ) : (t('filterResourceListButton'));

  return (
    <div className='CourseResourceFilterLauncherButton'>
      <Button
        aria-label={buttonLabel}
        basic
        className='course-resource-filter-launcher-button'
        disabled={isLoadingCategories || isCourseResourceFilterModalOpen}
        loading={isLoadingCategories}
        onClick={handleLaunchFilterModal}
        primary>
        <Icon name='filter' />
        {buttonLabel}
      </Button>
    </div>
  );
});

export default CourseResourceFilterLauncherButton;

SatCoreRegister('CourseResourceFilterLauncherButton', CourseResourceFilterLauncherButton);
